/*
      ##    #######   ##     ##  ########   ########   ##    ##   
      ##   ##     ##  ##     ##  ##         ##     ##   ##  ##    
      ##   ##     ##  ##     ##  ##         ##     ##    ####     
      ##   ##     ##  ##     ##  ######     ########      ##      
##    ##   ##  ## ##  ##     ##  ##         ##   ##       ##      
##    ##   ##    ##   ##     ##  ##         ##    ##      ##      
 ######     ##### ##   #######   ########   ##     ##     ##      
*/

$(document).ready(function() {

	FastClick.attach(document.body);

	$('[data-link]').click(function() {
		window.location.href = $(this).attr('data-link');
	}).find('a').click(function(e) {
		e.stopPropagation();
	});

	/**
	 * Test si les Media Queries sont supportées
	 * Ajoute la classe 'mq' au tag HTML si c'est le cas
	 */
	if ( Modernizr.mq('only all') ) {
		jQuery('html').addClass('mq');
	} else {
		jQuery('html').addClass('no-mq');
	}

	/**
	 * Browser detect : masquage de la bannière
	 */
	$('.browserdetect__close').click(function(e) {
		e.preventDefault();
		$('.browserdetect').addClass('browserdetect--hidden');
	});

	/**
	 * MatchHeight [GRID]
	 */
	$(".harmonize").matchHeight();

	/**
	 * Welcome video
	 */
	function videoIsPlaying() {
		return function() {
			$(this).addClass('is-playing');
		};
	}

	var fade_in_videos = $('.fade-in-video');
	for( i=0; i < fade_in_videos.length; i++ ) {
		fade_in_videos[i].addEventListener("playing", videoIsPlaying());
	}
	
	/**
	 * FitVids [Video responsive]
	 */
	$("#video-container").fitVids();

	/**
	 * Overlay video
	 */
	$('.show-video').click(function(e) {
		e.preventDefault();
		$('#video-overlay').addClass('show');
	});

	$('.hide-video').click(function(e) {
		e.preventDefault();
		$('#video-overlay').removeClass('show');
	});

	$('#video-overlay').click(function() {
		$(this).removeClass('show');
	}).find('div').click(function(e) {
		e.stopPropagation();
	});

	/**
	 * Scroll to content home page
	 */
	$(".go-down").click(function(e){
		e.preventDefault();
		$("body,html").animate({scrollTop: $('.section--content').offset().top}, 800);
	});


	/*
	 ######     #######   ##    ##   ########      ###      ######    ########   
	##    ##   ##     ##  ###   ##      ##        ## ##    ##    ##      ##      
	##         ##     ##  ####  ##      ##       ##   ##   ##            ##      
	##         ##     ##  ## ## ##      ##      ##     ##  ##            ##      
	##         ##     ##  ##  ####      ##      #########  ##            ##      
	##    ##   ##     ##  ##   ###      ##      ##     ##  ##    ##      ##      
	 ######     #######   ##    ##      ##      ##     ##   ######       ##      
	*/
	/**
	 * Contact form
	 */
	$("form").validationEngine({ 
		scroll: false,
		showPrompts: false,
		onFieldFailure: function(_input){
			_input.parent('li').addClass('error');
		},
		onFieldSuccess: function(_input){
			_input.parent('li').removeClass('error');
		}
	});

	$("input").focusin(function() {
		$(this).parent('li').addClass('input-active');
	}).blur(function() {
		if( $(this).val() === "" ) $(this).parent('li').removeClass('input-active');		
	});

	$("#fContact").submit(function(){
		if($("#fContact").validationEngine('validate')){
			var url  = $(this).attr('action');
			var data = $(this).serialize() + '&act=envoi';
			var div  = $(this).empty().html('<p class="form-return">Envoi en cours...</p>');

			$.ajax({
				type    : "POST",
				data    : data,
				url     : url,
				success : function(retour) {
					div.empty().append(retour);
				}
			});
		}
		return false;
	});

});
